import React from 'react';
import { NeuroMessage } from '../components';
import { ConversationTestProvider } from './state';
import ConversationTestPage from './components/CTPage';
import CTGuide from './components/CTGuide';
import CTProductsAll from './components/CTProductsAll';

const CONVERSATION_TEST_VIEWS = {
  questionFlow: {
    name: 'questionFlow',
    component: CTGuide,
    options: {
      enableQuestionMap: false,
      enableAppkeys: false,
      enablePageInfo: false,
      enableProductIds: false,
      enableProductDetails: false,
    },
    props: {},
  },
  allProducts: {
    name: 'allProducts',
    component: CTProductsAll,
    options: {
      enableProductIds: false,
      enableProductDetails: false,
    },
    props: {
      isFullHeight: true,
    },
  },
};

const ConversationTest = () => {
  return (
    <ConversationTestProvider
      defaultView={CONVERSATION_TEST_VIEWS.questionFlow}
      views={CONVERSATION_TEST_VIEWS}
    >
      <ConversationTestPage />
    </ConversationTestProvider>
  );
};

const ConversationTestLoading = () => {
  return (
    <div className="conversation-page-loading">
      <NeuroMessage id="convTest.loading" tagName="h1" />
    </div>
  );
};

export {
  ConversationTest as default,
  ConversationTestLoading,
  CONVERSATION_TEST_VIEWS,
};
